import { Fragment } from "react";
import { Carousel } from "@ww-digital/prism";
import { useRecipeResults } from "../../utils/useRecipeResults";
import styles from "./styles.module.scss";
import LoadingInterstitial from "./LoadingInterstitial";
import t from "../../utils/translate";

import dairy from "./img/dairy.svg";
import gluten from "./img/gluten.svg";
import kosher from "./img/kosher.svg";
import nuts from "./img/nuts.svg";
import vegan from "./img/vegan.svg";
import vegetarian from "./img/vegetarian.svg";

import recipeFallback from "./img/recipe-card-fallback.jpg";

const getRecipeIcon = icons => {
  return icons.map((icon, i) => {
    switch (icon) {
      case "Gluten-Free":
      case "Gluten free":
      case "Glutenvrij":
      case "Sans gluten":
      case "Sem glúten":
      case "Glutenfrei":
      case "Glutenfritt":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={gluten} alt={icon} />
          </div>
        );
      case "Kosher":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={kosher} alt={icon} />
          </div>
        );
      case "Vegan":
      case "Veganistisch":
      case "Végétalien":
      case "Vegana":
      case "Veganskt":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={vegan} alt={icon} />
          </div>
        );
      case "Nut-Free":
      case "Nut free":
      case "Nussfrei":
      case "Sans noix":
      case "Sans fruits à coque":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={nuts} alt={icon} />
          </div>
        );
      case "Vegetarian":
      case "Vegetarisch":
      case "Végétarien":
      case "Vegetariana":
      case "Vegetariskt (lakto-ovo)":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={vegetarian} alt={icon} />
          </div>
        );
      case "Dairy-Free":
      case "Dairy free":
      case "Non laitier":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={dairy} alt={icon} />
          </div>
        );
      default:
        return null;
    }
  });
};

const getRecipeCards = results =>
  results.items?.map((recipe, i) => {
    return {
      children: (
        <div
          className={styles.recipeCard}
          key={i}
          da-category="quiz"
          da-label="quiz:recipe_card"
          da-action="recipe_card"
          aria-label={`${recipe.title}, ${recipe.points} ${t("POINTS_ARIA_LABEL")}, ${recipe.dietary.join(", ")}`}
        >
          <div aria-hidden="true">
            <img
              className={styles.recipeImage}
              src={recipe.image ? recipe.image : recipeFallback}
              alt=""
            />
            <div className={styles.recipeCoin}>{recipe.points}</div>
            <div className={styles.recipeContent}>{recipe.title}</div>
            <div className={styles.recipeIconContainer}>
              {getRecipeIcon(recipe.dietary)}
            </div>
          </div>
        </div>
      )
    };
  });

const RecipeResults = () => {
  const { data: filteredResults, isLoading } = useRecipeResults();

  return (
    <>
      <LoadingInterstitial wrapperClassname={styles.loadingWrapper} />
      {!isLoading &&
        filteredResults?.map(results => (
          <Fragment key={results.title}>
            <h1 className={styles.cuisineLabel}>{results.title}</h1>
            <div className={styles.carouselWrapper}>
              <Carousel
                carouselItems={getRecipeCards(results)}
                carouselItemClassname="carouselSlideFlex"
                className={styles.carousel}
                options={{
                  fixedWidth: "192px",
                  gap: "16px",
                  type: "loop",
                  mediaQuery: "min",
                  arrows: false,
                  padding: { right: "50px", left: "10px" },
                  breakpoints: {
                    615: {
                      arrows: true
                    }
                  }
                }}
              />
            </div>
          </Fragment>
        ))}
    </>
  );
};

export default RecipeResults;
